module.exports = __webpack_public_path__ + "static/media/Comfortaa-Light.f525445c.ttf";